import React from 'react';

interface SectionLayoutProps {
    title: string;
    children: React.ReactNode;
}

const SectionLayout = (props: SectionLayoutProps) => {
    return (
        <div>
            <div className="px-6 py-5">
                <h1 className="text-xl font-bold">{props.title}</h1>
            </div>
            <hr />
            {props.children}
        </div>
    );
};

export default SectionLayout;
